import 'Modules/shareholders-id/modules/common/sid-common.module';

const sidAgentModule = angular.module('sidAgent', ['ui.router', 'sidCommon']);

/**
 * Services
 */
import issuerRepository from './model/repositories/issuer-repository.service';

sidAgentModule.service('AG_IssuerRepository', issuerRepository);

export default sidAgentModule;
